import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DashboardFilterActions } from "../../services/filters/reducer";
import useDashboardContext from "../../services/hooks/useDashboardContext";
import { FreshDashboardState } from "../../services/types";

interface FilterItemProps {
	type: string;
	fetchDataAndApplyNewDataToDashboardState: (
		freshDashboardStateComingFromEventHandler?: Partial<FreshDashboardState>
	) => Promise<void>;
}

const FilterItem = ({ type, fetchDataAndApplyNewDataToDashboardState }: FilterItemProps): JSX.Element => {
	const { isEditMode, state, dispatch } = useDashboardContext();
	const { t } = useTranslation();
	const isSelected = state.filtersConfig.selectedFilter.dateRange === type;

	const reloadDashboardData = async () => {
		if (isSelected) return;

		dispatch({
			type: DashboardFilterActions.CHANGE_DATE_FILTER,
			data: type,
		});

		fetchDataAndApplyNewDataToDashboardState({ selectedDateRange: type });
	};
	return (
		<Button variant={isSelected ? "primary" : "default"} disabled={isEditMode} onClick={reloadDashboardData}>
			{t(`modules.dashboard.field.${type}.title`)}
		</Button>
	);
};
export default FilterItem;

// t(`modules.dashboard.field.today.title`);
// t(`modules.dashboard.field.yesterday.title`);
// t(`modules.dashboard.field.this_month.title`);
// t(`modules.dashboard.field.last_3_months.title`);
// t(`modules.dashboard.field.last_6_months.title`);
// t(`modules.dashboard.field.last_12_months.title`);
